// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';
import { USER_ROLES } from '@/app/constants/status-constants';

export default {
    name: 'ProfileDropdownMenu',
    components: {},
    directive: {},
    filters: {},
    mixins: [ userMixins, GoogleAnalyticsMixins ],
    props: {},
    data() {
        return {
			breederCustomerLoginPath: BREEDER_ROUTES.PUPPY_SALES,
			breederCustomerLoginLabel: "Breeder Login",
			isInBreederLogin: false,
		}
    },
    computed: {
		userRole(){
			return this.$store.getters.getUserDetails.userRole;
		}
	},
    watch: {
		'$route': {
			handler(url) {
				if(url && url.path){
					this.handleRouteChange(url.path);
				}
			}
		},
	},
    created() {
		this.handleRouteChange(this.$route.path);
	},
    methods: {
		handleRouteChange(url){
			if(!Object.values(BREEDER_ROUTES).includes(url)){
				this.isInBreederLogin = false; 
				this.breederCustomerLoginLabel = "Breeder Login";
			} else {

				// only change the login label if the user is not a PURE breeder
				if(this.$store.getters.getUserDetails.userRole !== USER_ROLES.BREEDER){
					this.breederCustomerLoginLabel = "Customer Homepage";
				}

				this.isInBreederLogin = true; 
			}
		},
		sendUserSettingAnalytics(type, hasSwitchRoles = false) {
			// sendUserSettingAnalytics
			let action = '';
			let label = '';

			switch(type) {
				case 'profile':
					action = GA.USER_SETTINGS.PROFILE_BUTTON.ACTION;
					label = GA.USER_SETTINGS.PROFILE_BUTTON.LABEL;
					break;

				case 'upgrade':
					action = GA.USER_SETTINGS.UPGRADE_BUTTON.ACTION;
					label = GA.USER_SETTINGS.UPGRADE_BUTTON.LABEL;
					break;

				case 'settings':
					action = GA.USER_SETTINGS.SETTINGS_BUTTON.ACTION;
					label = GA.USER_SETTINGS.SETTINGS_BUTTON.LABEL;
			}

			this.sendEventTrackingToGA(action, GA.USER_SETTINGS.CATEGORY, label);
			
			// will only be true for "Breeder Login" button
			if(hasSwitchRoles){
				if(this.$store.getters.getUserDetails.userRole === USER_ROLES.BREEDER){
					
					if(this.$route.path === BREEDER_ROUTES.PUPPY_SALES){
						return;
					}
					
					this.$router.push(BREEDER_ROUTES.PUPPY_SALES);
				}
				// check if the user is not already a breeder and is currently in the "breeder login" page
				else if (this.isInBreederLogin && Object.values(BREEDER_ROUTES).includes(this.$route.path)){
					// fallback to manually switch routes
					if(this.$route.path !== "/dashboard"){
						this.$router.push("/dashboard");
					}
					
					// will only be true if the user created new breeder and hasn't switch yet to routes for CUSTOMER
					if(this.$store.getters.getHasSwitchToBreederRole && !Object.values(BREEDER_ROUTES).includes(this.$route.path)){
						this.$store.commit('setHasSwitchToBreederRole', false);
					}

					if(this.$route.path === "/dashboard"){
						// return back as customer
						this.breederCustomerLoginPath = "/dashboard";
						this.breederCustomerLoginLabel = "Breeder Login";
					}
				}
				else {
					// fallback to manually switch routes
					if(this.$route.path !== BREEDER_ROUTES.PUPPY_SALES){
						this.$router.push(BREEDER_ROUTES.PUPPY_SALES);
					}
					
					this.breederCustomerLoginPath = BREEDER_ROUTES.PUPPY_SALES;
					this.breederCustomerLoginLabel = "Customer Login";
				}
			}
		},
		logoutUser() {
			this.$store.dispatch('logout');
        }
    },
}